var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shop-view"}},[_c('Shop',{attrs:{"content":_vm.content,"checkoutUrl":"checkout-albigny","api":"cityaventure-lyon-albigny","wordFilter":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }